import useSWR from "swr";
import axios, { AxiosError } from "axios";
import { useContext } from "react";
import { AuthContext } from "contexts/auth";

type UserIconData = {
  icon: string | undefined;
  error: AxiosError | undefined;
  isLoading: boolean;
};

const useUserIcon = (): UserIconData => {
  const { token, userType } = useContext(AuthContext);
  const fetchWithToken = (url: any, token: any) =>
    axios.get(url, token).then((res) => res.data);

  const endpoint =
    userType === "Worker"
      ? `${process.env.APP_API_PATH}/crew/userinfo`
      : `${process.env.APP_API_PATH}/owner/userinfo`;

  const { data, error, isLoading } = useSWR([endpoint, token], ([url, token]) =>
    fetchWithToken(url, token)
  );

  const icon = data?.photos?.[0]?.path || undefined;

  return {
    icon,
    error,
    isLoading
  };
};

export default useUserIcon;
